import { Mapper } from "../../../../base/utils/mapper";
import { BiomicroscopyResponseModel } from "../../../../domain/models/consult/biomicroscopy-response.model";
import { BiomicroscopyResponseEntity } from "../entities/biomicroscopy-response.entity";

export class BiomicroscopyImplementationRepositoryMapper extends Mapper<BiomicroscopyResponseEntity, BiomicroscopyResponseModel> {
    mapFrom(param: BiomicroscopyResponseEntity): BiomicroscopyResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: BiomicroscopyResponseModel): BiomicroscopyResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}